import { CardActionArea, CardMedia as MuiCardMedia, Stack as MuiStack } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { ModuleType, type IToken } from "@framework/types";
import { Card, Typography } from "@dzambalaorg/ui-kit";

import { RarityBadge } from "../../../../components/common/badge";

interface IMyTokenListItemProps {
  token: IToken;
}

export const MyTokenListItem = (props: IMyTokenListItemProps) => {
  const { token } = props;

  const navigateTo =
    token.template?.contract?.contractModule === ModuleType.LOTTERY ||
    token.template?.contract?.contractModule === ModuleType.RAFFLE
      ? `/${token.template?.contract?.contractModule?.toLowerCase()}/tokens/${token.id}/view`
      : `/${token.template?.contract?.contractType?.toLowerCase()}/tokens/${token.id}/view`;

  const balance = token.balance![0].amount;

  return (
    <CardActionArea component={RouterLink} to={navigateTo}>
      <Card
        header={
          <Card.Header
            title={<MuiCardMedia image={token.template!.imageUrl} />}
            subheader={<Typography variant="h5">{token.template!.title}</Typography>}
          />
        }
      >
        <RarityBadge token={token} />
        <MuiStack direction="row" gap={2}>
          <Typography variant="numeric">
            <FormattedMessage id="pages.token.balanceTitle" />
          </Typography>
          <Typography variant="numeric">{balance}</Typography>
        </MuiStack>
      </Card>
    </CardActionArea>
  );
};
